import { addMinutes, differenceInMinutes, OwaDate } from 'owa-datetime';

/**
 * Calculate OwaDate by substracting the offset from start date
 */
export function calculateOwaDateTimeFromOffset(start: OwaDate, reminderOffset: number): OwaDate {
    return addMinutes(start, -1 * reminderOffset);
}

export function calculateOffsetFromOwaDates(curReminderDate: OwaDate, start: OwaDate): number {
    return differenceInMinutes(start, curReminderDate);
}
